import React, { useEffect, useState } from 'react'
import queryString from 'qs'
import styled from 'styled-components'
import ErrorBoundary from 'components/errorBoundary'
import DocumentPDF from './DocumentPDF'

const Container = styled.div`
  width: 100%;
  margin-top: 20px;

  canvas {
    width: 100% !important;
    height: auto !important;
    border-radius: 5px;
  }
`

const CertificateTab = ({ certificates, schoolId }) => {
  const baseURL = process.env.REACT_APP_API_URL
  const accessToken = JSON.parse(localStorage.getItem('accessToken')).id
  const [certificateUrl, setCertificateUrl] = useState(null)

  useEffect(() => {
    if (!certificates || certificates.length <= 0 || !schoolId) {
      return
    }

    const query = queryString.stringify({
      data: JSON.stringify({
        ...certificates[0].certificateTemplate,
        courseName: certificates[0].name,
      }),
      access_token: accessToken,
    })
    const url = `${baseURL}/Schools/${schoolId}/previewCertificate?${query}`
    setCertificateUrl(url)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [certificates, schoolId])

  return (
    <ErrorBoundary>
      <Container>
        <DocumentPDF url={certificateUrl} />
      </Container>
    </ErrorBoundary>
  )
}

export default CertificateTab
